


import React, { useState, useEffect, useMemo } from 'react'
import Layout from '../../Component/Layout'
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CharacteristicsModal from '../../Component/CharacteristicsModal ';
import { ORDER_API } from "../../apiConfig";

function Packing() {
    const [salesOrganization, setSalesOrganization] = useState("");
    const [division, setDivision] = useState("");
    const [dChannel, setDChannel] = useState("");
    const [piId, setPiId] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [rfqSummary, setRfqSummary] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [modalData, setModalData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('');
    const [activeTab, setActiveTab] = useState("product");
    const [selectedHandling, setSelectedHandling] = useState({});
    const [expandedSoId, setExpandedSoId] = useState(null);
    const [expandedProductSoId, setExpandedProductSoId] = useState(null);
    const [expandedDocsSoId, setExpandedDocsSoId] = useState(null);
    const [showCharModal, setShowCharModal] = useState(false);
    const [selectedCharData, setSelectedCharData] = useState([]);

    useEffect(() => {
        const fetchSummary = async () => {
            try {
const res = await fetch(`${ORDER_API}/packing/summary/created`);
                const data = await res.json();
                setRfqSummary(data);
            } catch (err) {
                console.error('Failed to load RFQ summary:', err);
            }
        };
        fetchSummary();
    }, []);

    const dropdownOptions = useMemo(() => {
        const getUnique = (key) => [...new Set(rfqSummary.map(item => item[key]).filter(Boolean))];

        return {
            salesOrgs: getUnique('sales_organization'),
            divisions: getUnique('division'),
            channels: getUnique('distribution_channel'),
            customers: getUnique('customer'),
            piIds: getUnique('pi_id'),
        };
    }, [rfqSummary]);

    const filteredData = useMemo(() => {
        return rfqSummary.filter((item) => {
            return (
                (salesOrganization === "" || item.sales_organization === salesOrganization) &&
                (division === "" || item.division === division) &&
                (dChannel === "" || item.distribution_channel === dChannel) &&
                (selectedCustomer === "" || item.customer === selectedCustomer) &&
                (piId === "" || item.pi_id === piId)
            );
        });
    }, [rfqSummary, salesOrganization, division, dChannel, selectedCustomer, piId]);

    useEffect(() => {
        if (showModal) {
            setActiveTab("product");
            setSelectedHandling({});
        }
    }, [showModal]);

    const handleShowCharacteristics = (charData) => {
        let parsedData = [];
        try {
            parsedData = typeof charData === 'string' ? JSON.parse(charData) : charData;
        } catch (e) {
            parsedData = [];
        }
        setSelectedCharData(parsedData || []);
        setShowCharModal(true);
    };

    const renderBasicInfoContent = (item) => (
        <div className="row g-3 mt-1">

            <div className="col-md-6">
                <label style={{ ...styles.compactLabel, fontWeight: 'normal' }}>Picking Id</label>
                <div className="form-control form-control-sm" style={{ ...styles.compactInput, fontWeight: 'normal' }}>
                    {item.pi_id}
                </div>
            </div>
            <div className="col-md-6">
                <label style={{ ...styles.compactLabel, fontWeight: 'normal' }}>OD Id</label>
                <div className="form-control form-control-sm" style={{ ...styles.compactInput, fontWeight: 'normal' }}>
                    {item.od_id}
                </div>
            </div>
            <div className="col-md-6">
                <label style={{ ...styles.compactLabel, fontWeight: 'normal' }}>Sales Organization</label>
                <div className="form-control form-control-sm" style={{ ...styles.compactInput, fontWeight: 'normal' }}>
                    {item.salesOrganization}
                </div>
            </div>
            <div className="col-md-6">
                <label style={{ ...styles.compactLabel, fontWeight: 'normal' }}>Division</label>
                <div className="form-control form-control-sm" style={{ ...styles.compactInput, fontWeight: 'normal' }}>
                    {item.division}
                </div>
            </div>
            <div className="col-md-6">
                <label style={{ ...styles.compactLabel, fontWeight: 'normal' }}>Distribution Channel</label>
                <div className="form-control form-control-sm" style={{ ...styles.compactInput, fontWeight: 'normal' }}>
                    {item.distributionChannel}
                </div>
            </div>
        </div>
    );

    const renderProductContent = (item) => (
        <div style={{
            ...styles.tableContainer,
            overflowX: 'auto',
            marginTop: '1rem',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            width: '100%'
        }}>
            <table className="table table-hover mb-0" style={{
                ...styles.erpTable,
                width: 'max-content',
                minWidth: '100%',
                tableLayout: 'auto',
                borderCollapse: 'collapse'
            }}>
                <thead>
                    <tr style={{ backgroundColor: '#f8fafc' }}>
                        <th style={{ ...styles.erpTh, textAlign: "center", width: '50px' }}>Item</th>
                        <th style={{ ...styles.erpTh, whiteSpace: "nowrap" }}>OD ID</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>SO ID</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Product Code</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Description</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Class</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>UOM</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Quantity</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Req. Date</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Del. Qty</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '180px' }}>Batch Number</th>
                        {/* <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '120px' }}>Storage Bin</th> */}
                        {modalType === 'convert' && (
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '150px' }}>Handling Id</th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {item.productDetails?.length === 0 ? (
                        <tr>
                            <td colSpan={12} style={{ ...styles.erpTd, textAlign: "center", padding: '20px' }}>
                                No Products Found
                            </td>
                        </tr>
                    ) : (
                        item.productDetails?.map((prod, idx) => {
                            return (
                                <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ ...styles.erpTd, textAlign: "center" }}>{idx + 1}</td>
                                    <td style={styles.erpTd}>{prod.od_id}</td>
                                    <td style={styles.erpTd}>{prod.so_id}</td>
                                    <td style={styles.erpTd}>{prod.product_code}</td>
                                    <td style={styles.erpTd}>{prod.description}</td>

                                    {/* 4. Updated Class Column with Arrow */}
                                    <td style={styles.erpTd}>
                                        {prod.product_class}
                                        {prod.characteristics && (
                                            <span
                                                style={{ cursor: 'pointer', marginLeft: '8px', color: '#111111', fontSize: '12px' }}
                                                onClick={() => handleShowCharacteristics(prod.characteristics)}
                                                title="View Characteristics"
                                            >
                                                ▶
                                            </span>
                                        )}
                                    </td>

                                    <td style={styles.erpTd}>{prod.uom}</td>
                                    <td style={styles.erpTd}>{prod.quantity}</td>
                                    <td style={styles.erpTd}>
                                        {/* {prod.requirement_date
                                            ? new Date(prod.requirement_date).toLocaleDateString("en-GB")
                                            : "N/A"} */}
                                        {prod.requirement_date ? (() => {
                                            const d = new Date(prod.requirement_date);
                                            const day = String(d.getDate()).padStart(2, '0');
                                            const month = String(d.getMonth() + 1).padStart(2, '0');
                                            const year = d.getFullYear();
                                            return `${day}/${month}/${year}`;
                                        })() : "N/A"}
                                    </td>
                                    <td style={styles.erpTd}>{prod.delivery_qty}</td>
                                    <td style={styles.erpTd}>{prod.batch_number}</td>
                                    {/* <td style={styles.erpTd}>{prod.storage_bin}</td> */}
                                    {modalType === 'convert' && (
                                        <td style={styles.erpTd}>
                                            <select
                                                className="form-control form-control-sm"
                                                value={selectedHandling[prod.id] || ""}
                                                onChange={(e) => handleHandlingChange(prod.id, e.target.value)}
                                                style={{ fontWeight: 'normal', border: '1px solid #aaa' }}
                                            >
                                                <option value="">-- Select --</option>
                                                <option value="Handling-1">Handling-1</option>
                                                <option value="Handling-2">Handling-2</option>
                                                <option value="Handling-3">Handling-3</option>
                                                <option value="Handling-4">Handling-4</option>
                                            </select>
                                        </td>
                                    )}
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </div>
    );

    const renderDocsContent = (item) => (
        <div className="list-group mt-3">
            {item.pdfFilePath && (
                <div className="list-group-item d-flex justify-content-between align-items-center">
                    <div>
                        <i className="bi bi-file-earmark-pdf me-2"></i>
                        <span>
                            {item.pi_id ? `Delivery Invoice (${item.bi_id})` : "Generated Delivery PDF"}
                        </span>
                    </div>
                    <a href={``} download className="btn btn-sm border">
                        <i className="bi bi-download me-1"></i> Download
                    </a>
                </div>
            )}
            {item.documents?.map((file, idx) => (
                <div className="list-group-item d-flex justify-content-between align-items-center" key={idx}>
                    <div>
                        <i className="bi bi-file-earmark me-2"></i>
                        <span>{file.file_name}</span>
                    </div>
                    <a href={file.file_url.startsWith('http') ? file.file_url : ``} download className="btn btn-sm border">
                        <i className="bi bi-download"></i>
                    </a>
                </div>
            ))}
            {!item.pdfFilePath && (!item.documents || item.documents.length === 0) && (
                <div className="list-group-item text-center py-4 text-muted border-0">
                    No documents available.
                </div>
            )}
        </div>
    );

    const handleOpenModal = async () => {
        const firstSelectedCustomer = rfqSummary.find(item => selectedRows.includes(item.pi_id))?.customer;
        const allSameCustomer = selectedRows.every(piId => {
            const customer = rfqSummary.find(item => item.pi_id === piId)?.customer;
            return customer === firstSelectedCustomer;
        });

        if (!allSameCustomer) { alert("Please select Picking IDs of the same customer."); return; }

        const selectedData = rfqSummary.filter(item => selectedRows.includes(item.pi_id));
        const pi_ids = selectedData.map(item => item.pi_id);

        if (pi_ids.length > 0) {
            try {
                const responses = await Promise.all(pi_ids.map(piId =>
                    fetch(`${ORDER_API}/packing/accepted/pi/${piId}`).then(res => res.json())
                ));
                setModalData(responses);
                setModalType('convert');
                setShowModal(true);
            } catch (error) { console.error(error); alert("Error fetching data"); }
        } else { alert("No Picking ID selected!"); }
    };

    const handleViewClick = async (pi_id) => {
        try {
            const res = await fetch(`${ORDER_API}/packing/accepted/pi/${pi_id}`);
            const data = await res.json();
            setModalData([data]);
            setModalType('view');
            setShowModal(true);
        } catch (error) {
            console.error("Error fetching RFQ details:", error);
        }
    };

    const handleCheckboxChange = (piId) => {
        setSelectedRows((prev) => {
            const isSelected = prev.includes(piId);
            if (isSelected) return prev.filter(id => id !== piId);

            const selectedItem = rfqSummary.find(item => item.pi_id === piId);
            const selectedCust = selectedItem?.customer;

            const firstCust = prev.length > 0
                ? rfqSummary.find(item => item.pi_id === prev[0])?.customer
                : null;

            if (firstCust && selectedCust !== firstCust) {
                alert("Please select Picking ID of the same customer.");
                return prev;
            }

            return [...prev, piId];
        });
    };

    const handleSelectAllChange = (checked) => {
        if (checked) {
            if (filteredData.length === 0) return;
            const firstCustomer = filteredData[0].customer;
            const sameCustomerItems = filteredData.filter(item => item.customer === firstCustomer);
            if (sameCustomerItems.length !== filteredData.length) {
                toast.warning("Selected only items matching the first customer in list.");
            }
            setSelectedRows(sameCustomerItems.map(item => item.pi_id));
        } else {
            setSelectedRows([]);
        }
    };

    const generateUniquePaId = (baseTime, index) => {
        const now = baseTime || new Date();
        const pad = (n) => n.toString().padStart(2, "0");
        const base = `PA${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
        return index === 0 ? base : `${base}-${index}`;
    };

    const handleSavePacking = async () => {
        const packingList = [];
        const baseTime = new Date();
        const handlingToPaIdMap = {};
        let groupIndex = 0;

        const generateUniquePaId = (index) => {
            const now = baseTime;
            const pad = (n) => n.toString().padStart(2, "0");
            const base = `PA${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
            return `${base}${pad(index)}`;
        };

        let hasError = false;

        modalData.forEach(item => {
            item.productDetails?.forEach(prod => {
                const handling = selectedHandling[prod.id];

                if (!handling) {
                    toast.error(`Please select handling for Product: ${prod.product_code} (Batch: ${prod.batch_number})`);
                    hasError = true;
                    return;
                }

                // If this handling ID hasn't been seen yet, generate a new PA ID for it
                if (!handlingToPaIdMap[handling]) {
                    handlingToPaIdMap[handling] = generateUniquePaId(groupIndex++);
                }

                packingList.push({
                    id: prod.id, // Row ID
                    pi_id: prod.pi_id,
                    pa_id: handlingToPaIdMap[handling], // Assign the mapped PA ID
                    handling: handling
                });
            });
        });

        if (hasError) return;
        if (packingList.length === 0) return;

        try {
            const response = await fetch(`${ORDER_API}/packing/finalize-packing-bulk`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ packingList }),
            });

            const data = await response.json();

            if (response.ok) {
                // Show generated IDs
                const uniquePaIds = [...new Set(packingList.map(p => p.pa_id))].join(', ');
                toast.success(`Packing IDs created: ${uniquePaIds}`);
                setShowModal(false);
                setSelectedRows([]);
                window.location.reload();
            } else {
                toast.error(`Error: ${data.message}`);
            }
        } catch (error) {
            console.error("Error finalizing packing:", error);
            toast.error("An error occurred while creating packing.");
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        // setSelectedRows([]); // Keep selection if desired, or clear it
    };

    const handleToggle = (tab, piId) => {
        if (tab === "basic") setExpandedSoId(prev => prev === piId ? null : piId);
        if (tab === "product") setExpandedProductSoId(prev => prev === piId ? null : piId);
        if (tab === "docs") setExpandedDocsSoId(prev => prev === piId ? null : piId);
    };

    const handleHandlingChange = (rowId, value) => {
        // 1. Find the PI group (parent item)
        const parentItem = modalData.find(item =>
            item.productDetails?.some(prod => prod.id === rowId)
        );

        if (!parentItem) return;

        const currentPiId = parentItem.pi_id;

        // 2. Validation
        if (value) {
            const otherProductsInSamePi = parentItem.productDetails.filter(p => p.id !== rowId);

            for (const prod of otherProductsInSamePi) {
                const existingSelection = selectedHandling[prod.id];

                if (existingSelection && existingSelection !== value) {
                    // --- ARTICULATED MESSAGE ---
                    toast.error(`Configuration Error: All items within Picking ID ${currentPiId} must share the same Handling ID. Currently assigned to: ${existingSelection}.`);
                    return;
                }
            }
        }

        // 3. Update State
        setSelectedHandling(prev => ({
            ...prev,
            [rowId]: value
        }));
    };

    return (
        <Layout>
            <div style={styles.pageTitleBar}>
                <div>
                    <div style={styles.pageTitle}>Packing</div>
                    <div style={styles.pageSubtitle}>Manage and view your data here</div>
                </div>
                <button className="btn btn-dark" style={styles.primaryBtn} onClick={handleOpenModal}>
                    + Create Packing
                </button>
            </div>

            {/* Filter Card */}
            <div style={styles.filterCard}>
                <div className="row g-4">
                    <div className="col-md-2 col-sm-4">
                        <label style={styles.filterLabel}>Sales Organization</label>
                        <select className="form-control" style={styles.filterSelect} value={salesOrganization} onChange={(e) => setSalesOrganization(e.target.value)}>
                            <option value="">Select</option>
                            {dropdownOptions.salesOrgs.map((org) => <option key={org} value={org}>{org}</option>)}
                        </select>
                    </div>
                    <div className="col-md-2 col-sm-4">
                        <label style={styles.filterLabel}>Division</label>
                        <select className="form-control" style={styles.filterSelect} value={division} onChange={(e) => setDivision(e.target.value)}>
                            <option value="">Select</option>
                            {dropdownOptions.divisions.map((div) => <option key={div} value={div}>{div}</option>)}
                        </select>
                    </div>
                    <div className="col-md-2 col-sm-4">
                        <label style={styles.filterLabel}>Distribution Channel</label>
                        <select className="form-control" style={styles.filterSelect} value={dChannel} onChange={(e) => setDChannel(e.target.value)}>
                            <option value="">Select</option>
                            {dropdownOptions.channels.map((chan) => <option key={chan} value={chan}>{chan}</option>)}
                        </select>
                    </div>
                    <div className="col-md-2 col-sm-4">
                        <label style={styles.filterLabel}>Picking ID</label>
                        <select className="form-control" style={styles.filterSelect} value={piId} onChange={(e) => setPiId(e.target.value)}>
                            <option value="">select</option>
                            {dropdownOptions.piIds.map((id) => <option key={id} value={id}>{id}</option>)}
                        </select>
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <label style={styles.filterLabel}>Customer</label>
                        <select className="form-control" style={styles.filterSelect} value={selectedCustomer} onChange={(e) => setSelectedCustomer(e.target.value)}>
                            <option value="">Select</option>
                            {dropdownOptions.customers.map((cust) => <option key={cust} value={cust}>{cust}</option>)}
                        </select>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div style={styles.tableContainer}>
                <table className="table" style={styles.erpTable}>
                    <thead>
                        <tr>
                            <th style={{ ...styles.erpTh, width: 50, textAlign: "center" }}>
                                <input
                                    type="checkbox"
                                    checked={filteredData.length > 0 && selectedRows.length > 0 && filteredData.every(item => selectedRows.includes(item.pi_id))}
                                    onChange={(e) => handleSelectAllChange(e.target.checked)}
                                />
                            </th>
                            <th style={{ ...styles.erpTh, width: 150 }}>Picking ID</th>
                            <th style={{ ...styles.erpTh, width: 150 }}>OD ID</th>
                            <th style={{ ...styles.erpTh, width: 150 }}>Customer</th>
                            <th style={{ ...styles.erpTh, width: 150 }}>Total Price</th>
                            <th style={{ ...styles.erpTh, width: 150 }}>Status</th>
                            <th style={{ ...styles.erpTh, width: 100 }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length === 0 ? (
                            <tr><td colSpan="6" style={{ ...styles.erpTh, textAlign: "center" }}>No Records Found</td></tr>
                        ) : (
                            filteredData.map((item) => (
                                <tr key={item.pi_id} style={{ backgroundColor: item.status === 'approved' ? "#f2f2f2" : "white", opacity: item.status === 'approved' ? 0.6 : 1 }}>
                                    <td style={{ ...styles.erpTh, width: 50, textAlign: "center" }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedRows.includes(item.pi_id)}
                                            onChange={() => handleCheckboxChange(item.pi_id)}
                                        />
                                    </td>
                                    <td style={styles.erpTd}>{item.pi_id || ""}</td>
                                    <td style={styles.erpTd}>{item.od_id}</td>
                                    <td style={styles.erpTd}>{item.customer || ""}</td>
                                    <td style={styles.erpTd}>{item.total_price}</td>
                                    <td style={styles.erpTd}>{item.status}</td>
                                    <td style={styles.erpTd}>
                                        <button className="btn btn-outline-dark btn-sm" onClick={() => handleViewClick(item.pi_id)}>View</button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* --- MODAL --- */}
            {showModal && modalData.length > 0 && (
                <div style={styles.modalBackdrop}>
                    <div style={{ ...styles.modal, maxWidth: "1200px", width: "90%", maxHeight: "90vh" }}>

                        <div style={styles.modalHeader}>
                            <div style={{ fontWeight: 600, fontSize: '1.2rem' }}>
                                {modalType === 'convert' ? `Packing` : `Packing : ${modalData[0]?.pi_id}`}
                            </div>
                            <button style={styles.iconBtn} onClick={handleCloseModal}>✕</button>
                        </div>

                        <div style={styles.modalBody}>
                            <div className="mt-3 p-3" style={{ border: '1px solid #e2e8f0', borderRadius: '8px', backgroundColor: '#ffffff' }}>
                                {/* Existing Customer Row */}
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <label className="form-label fw-bold mb-2" style={{ fontSize: '14px', color: '#1e293b' }}>Customer</label>
                                        <div className="form-control d-flex align-items-center justify-content-between"
                                            style={{ minHeight: '42px', fontSize: '14px', color: '#64748b', backgroundColor: '#f8fafc', border: '1px solid #000000', borderRadius: '6px', cursor: 'default', padding: '0 12px' }}>
                                            <span>{modalData[0]?.customer || "N/A"}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* NEW SECTION: Partner Details */}
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold mb-1" style={{ fontSize: '13px', color: '#1e293b' }}>Shipping Address</label>
                                        <div className="p-2" style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '13px', minHeight: '38px', color: '#475569' }}>
                                            {modalData[0]?.registeredAddress || "N/A"}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold mb-1" style={{ fontSize: '13px', color: '#1e293b' }}>Billing Address</label>
                                        <div className="p-2" style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '13px', minHeight: '38px', color: '#475569' }}>
                                            {modalData[0]?.communicationAddress || "N/A"}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold mb-1" style={{ fontSize: '13px', color: '#1e293b' }}>Payment Terms</label>
                                        <div className="p-2" style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '13px', minHeight: '38px', color: '#475569' }}>
                                            {modalData[0]?.paymentTerms || "N/A"}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{ ...styles.tabs, marginBottom: "10px" }}>
                                {/* <button className={`btn ${activeTab === "basic" ? "btn-secondary" : "btn-light"}`} onClick={() => setActiveTab("basic")} style={styles.compactTabBtn}>Basic Info</button> */}
                                <button className={`btn ${activeTab === "product" ? "btn-secondary" : "btn-light"}`} onClick={() => setActiveTab("product")} style={styles.compactTabBtn}>Product</button>
                                <button className={`btn ${activeTab === "docs" ? "btn-secondary" : "btn-light"}`} onClick={() => setActiveTab("docs")}>Documents</button>
                            </div>

                            {/* {activeTab === "basic" && (
                                <div>
                                    {modalData.map((item) => (
                                        <div key={item.pi_id} style={{ marginBottom: "15px" }}>
                                            {modalType === 'view' ? (
                                                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#fff" }}>
                                                    {renderBasicInfoContent(item)}
                                                </div>
                                            ) : (
                                                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
                                                    <div
                                                        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                                                        onClick={() => handleToggle("basic", item.pi_id)}
                                                    >
                                                        <div className="d-flex align-items-center gap-2">
                                                            <h6 style={{ margin: 0 }}>{item.pi_id}</h6>
                                                            {selectedHandling[item.pi_id] && (
                                                                <span className="badge bg-dark">{selectedHandling[item.pi_id]}</span>
                                                            )}
                                                        </div>
                                                        <i className={`bi bi-chevron-${expandedSoId === item.pi_id ? "down" : "right"}`} style={{ fontSize: "18px" }}></i>
                                                    </div>
                                                    {expandedSoId === item.pi_id && renderBasicInfoContent(item)}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )} */}

                            {activeTab === "product" && (
                                <div>
                                    {modalData.map((item) => (
                                        <div key={item.pi_id} style={{ marginBottom: "15px" }}>
                                            {modalType === 'view' ? (
                                                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#fff" }}>
                                                    {renderProductContent(item)}
                                                </div>
                                            ) : (
                                                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
                                                    <div
                                                        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                                                        onClick={() => handleToggle("product", item.pi_id)}
                                                    >
                                                        <h6 style={{ margin: 0 }}>{item.pi_id}</h6>
                                                        <i className={`bi bi-chevron-${expandedProductSoId === item.pi_id ? "down" : "right"}`} style={{ fontSize: "18px" }}></i>
                                                    </div>
                                                    {expandedProductSoId === item.pi_id && renderProductContent(item)}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {activeTab === "docs" && (
                                <div>
                                    {modalData.map((item) => (
                                        <div key={item.pi_id} style={{ marginBottom: "15px" }}>
                                            {modalType === 'view' ? (
                                                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#fff" }}>
                                                    {renderDocsContent(item)}
                                                </div>
                                            ) : (
                                                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
                                                    <div
                                                        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                                                        onClick={() => handleToggle("docs", item.pi_id)}
                                                    >
                                                        <h6 style={{ margin: 0 }}>{item.pi_id}</h6>
                                                        <i className={`bi bi-chevron-${expandedDocsSoId === item.pi_id ? "down" : "right"}`} style={{ fontSize: "18px" }}></i>
                                                    </div>
                                                    {expandedDocsSoId === item.pi_id && renderDocsContent(item)}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div style={styles.modalFooter}>
                            <button className="btn btn-outline-secondary" onClick={handleCloseModal}>Close</button>
                            {modalType === 'convert' && (<button className="btn btn-dark" onClick={handleSavePacking}>Create Packing</button>)}
                        </div>

                    </div>
                </div>
            )}

            <CharacteristicsModal
                modalVisible={showCharModal}
                handleClose={() => setShowCharModal(false)}
                selectedCharacteristics={selectedCharData}
                isEditing={false}
            />
            <ToastContainer position="top-right" autoClose={3000} />
        </Layout>
    );
}

const styles = {
    compactLabel: { fontSize: "14px", fontWeight: 600, marginBottom: "4px" },
    compactInput: { fontSize: "14px", height: "32px", padding: "4px 8px" },
    compactTabBtn: { fontSize: "14px", padding: "4px 10px" },
    tableContainer: { background: "#ffffff", borderRadius: 8, padding: 12, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" },
    erpTable: { width: "100%", tableLayout: "auto", borderCollapse: "collapse" },
    erpTh: { background: "#f8fafc", fontSize: 13, fontWeight: 600, padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#1e293b", whiteSpace: "nowrap" },
    erpTd: { fontSize: 13, padding: "10px 12px", borderBottom: "1px solid #f1f5f9", color: "#334155", verticalAlign: "middle" },
    filterCard: { background: '#ffffff', borderRadius: 8, padding: 20, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: 18 },
    filterLabel: { fontSize: 13, fontWeight: 600, marginBottom: 6, color: '#334155' },
    filterSelect: { height: 36, fontSize: 13 },
    pageTitleBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 },
    pageTitle: { fontSize: 26, fontWeight: 700, color: '#1e293b', marginBottom: 2 },
    pageSubtitle: { fontSize: 13, color: '#64748b' },
    primaryBtn: { paddingLeft: 14, paddingRight: 14 },
    modalBackdrop: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050, padding: '20px' },
    modal: { background: '#fff', borderRadius: '8px', width: '90%', maxWidth: '1200px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
    modalHeader: { padding: '15px 20px', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    iconBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer' },
    modalBody: { padding: '20px', overflowY: 'auto', flex: 1 },
    modalFooter: { padding: '15px 20px', borderTop: '1px solid #ddd', display: 'flex', justifyContent: 'flex-end', gap: '10px' },
    tabs: { display: 'flex', gap: 8, margin: '14px 0' },
};

export default Packing
